import React, { FC } from 'react'
import Touchable from '@components/Touchable'
import { Avatar, Stack, Typography, useTheme } from '@mui/material'

interface LearnCardProps {
  color: string
  title: string
  category: string
  description?: string
  emoji?: string
  imageUrl?: string
  onClick?: () => void
  square?: boolean
}

const LearnCard: FC<LearnCardProps> = ({
  color,
  title,
  category,
  description,
  emoji,
  imageUrl,
  onClick,
  square = true,
}) => {
  const { palette } = useTheme()

  return (
    <Touchable onClick={onClick}>
      <Stack
        bgcolor={color}
        flex={1}
        borderRadius={2}
        p={2}
        justifyContent="space-between"
        sx={square ? { aspectRatio: 1 } : {}}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontSize={20} fontWeight="bold">
            {title}
          </Typography>
          <Avatar sx={{ bgcolor: palette.background.paper }} src={imageUrl}>
            {emoji}
          </Avatar>
        </Stack>
        <Stack>
          <Typography variant="caption" color="white">
            {category}
          </Typography>
          <Typography>{description}</Typography>
        </Stack>
      </Stack>
    </Touchable>
  )
}

export default LearnCard
